import { render, staticRenderFns } from "./ManifestKlaimPd.vue?vue&type=template&id=acae1f2e&scoped=true&"
import script from "./ManifestKlaimPd.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimPd.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimPd.vue?vue&type=style&index=0&id=acae1f2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acae1f2e",
  null
  
)

export default component.exports